import { ExaminationCourseCreationButton } from '@exam-management/examination-course-creation';
import {
  ExaminationCourseGroupSelection,
  ExaminationCourseList,
  ExaminationCourseSearchBox,
} from '@exam-management/examination-course-list';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { Box, Flex, Paper, Text } from '@shared/components';
import { PermissionGuard, WithPermission } from '@shared/permissions';

export default function ExamCoursesPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.EXAMINATION_COURSE.VIEW]}>
      <Flex sx={{ flexDirection: 'column', width: 1, height: '100dvh', bgcolor: 'grey.50' }}>
        <Flex
          sx={(theme) => ({
            px: theme.spacing(6),
            py: theme.spacing(8),
            justifyContent: 'space-between',
            alignItems: 'center',
          })}
        >
          <Text variant='h1'>หลักสูตรทดสอบ</Text>
          <WithPermission requiredPermission={APP_PERMISSIONS.EXAM.EXAMINATION_COURSE.CREATE}>
            <ExaminationCourseCreationButton />
          </WithPermission>
        </Flex>
        <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1, width: '100%' }}>
          <Paper
            sx={(theme) => ({
              width: '100%',
              height: '100%',
              borderRadius: theme.shape.rounded(2),
              p: theme.spacing(6),
            })}
          >
            <WithPermission requiredPermission={APP_PERMISSIONS.EXAM.EXAMINATION_COURSE.VIEW}>
              <Flex
                sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6), height: '100%' }}
              >
                <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box sx={{ maxWidth: '260px', width: '100%' }}>
                    <ExaminationCourseGroupSelection />
                  </Box>
                  <Box
                    sx={{ maxWidth: '300px', width: '100%', height: '100%', alignContent: 'end' }}
                  >
                    <ExaminationCourseSearchBox />
                  </Box>
                </Flex>
                <ExaminationCourseList />
              </Flex>
            </WithPermission>
          </Paper>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
